module.exports = __webpack_public_path__ + "img/person-icon.5924bd35.svg";